<app-breadcrumb [searchBreadcrumb]="search_name" [title]="page_name" [breadcrumb]="page_name" [query]="query" [formShapesMode]="formShapesMode"></app-breadcrumb>
<!-- section start -->
<section class="pt-0 authentication-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="search-content col">
                <!-- <section class="search-block" *ngIf="!formShapesMode">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <form class="form-header">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="exampleInputPassword1" name="query"
                                            [value]="query.split('-').join(' ')" placeholder="{{'Search a Product' | translate}}">
                                    </div>
                                    <button type="submit" class="btn btn-primary" (click)="goToSearch()"><i
                                            class="fa fa-search"></i></button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section> -->

                <div class="collection-product-wrapper" id="products">
                    <div class="product-wrapper-grid" [ngClass]="layoutView">
                        <div class="row">
                            <div class="col-grid-box" *ngFor="let product of allShownProducts">
                                <app-product-box-one [product]="product" [currency]="productService?.Currency"
                                    [thumbnail]="false" [cartModal]="true">
                                </app-product-box-one>
                            </div>
                            <div class="mt-5 text-center col-sm-12 section-b-space no-found" *ngIf="finished &&!allItems.length &&!allShownProducts.length">
                                <img src="assets/images/empty-search1.png" class="mb-4 img-fluid">
                                <h3>{{'Sorry Couldn find the product' | translate}} </h3>
                                <p></p>
                                <a [routerLink]="['/']" class="btn btn-solid">{{'continue shopping' | translate}}</a>
                            </div>
                        </div>
                    </div>

                        <div infiniteScroll [infiniteScrollDistance]="3" [infiniteScrollThrottle]="300" (scrolled)="onScroll()" *ngIf="allItems.length"
                            >
                        </div>
                        <div class="product-infinitescroll">
                            <div class="theme-paggination-block">
                                <div class="p-0 container-fluid">
                                    <div class="row">
                                        <div class="text-center col-sm-12">
                                            <div class="mt-3 mb-3 infinite-scrolling d-inline-block">
                                                <img src="assets/images/loader.gif" *ngIf="!finished">
                                                <div class="loading-more active" *ngIf="finished">
                                                    {{'No More Products' | translate}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section end -->